module.exports = __webpack_public_path__ + "static/media/yellow-star.7ebb47e4.svg";